import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ApiInterceptor } from '../interceptors/api.interceptor';

// TODO: refactor this to use new function based interceptors from angular see: https://angular.dev/guide/http/interceptors
export const provideCoreInterceptors = () => {
  return [{ provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true }];
};
